import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Icon from '../../../components/Icon';
import { humanizeDuration } from '../../../utils/humanizeDuration';
import { useTranslation } from 'react-i18next';
export const Duration = ({ avgTime, type, loading = false }) => {
    const { t } = useTranslation();
    const content = avgTime ? humanizeDuration(avgTime, 'seconds') : t('prMetrics.' + type + '.empty');
    return (_jsx("div", { className: "metrics__duration", children: loading ? (_jsx("div", { className: "text-center", children: _jsx(Icon, { name: "spinner", spin: true, fixedWidth: true, pulse: true }) })) : (content) }));
};
